export default __webpack_public_path__ + "static/media/Luke-Compressed.bd22b1e7.png";